import { LOGOUT } from "../actions/loginAction";
import {
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  SOCIAL_LOGIN_SUCCESS,
  SOCIAL_LOGIN_FAIL,
  SOCIAL_SSO_LOGIN_SUCCESS,
  SOCIAL_SSO_LOGIN_FAIL,
} from "../actionTypes";

const initialState = {
  user: [],
  loading: false,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoggedIn: true,
        user:
          action?.payload?.user && action?.payload?.user?.body
            ? action?.payload?.user
            : { body: {} },
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case SOCIAL_LOGIN_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoggedIn: true,
        user: action.payload.user || {},
      };
    case SOCIAL_LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case SOCIAL_SSO_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoggedIn: true,
        user: action.payload.user || {},
      };
    case SOCIAL_SSO_LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return { ...initialState };
    default:
      break;
  }

  return state;
};

export default loginReducer;
